import { baseClient, authClient, API } from '../index';
import { shrinkImageForUpload } from '../../utils/compressImage';

/**
 * Subida de foto en el registro de grupo.
 * Usa axios (no fetch): en Safari/iPad muchas peticiones fetch cross-origin fallan con
 * "TypeError: Load failed" sin llegar al servidor.
 * Antes se reduce la imagen para evitar cortes en nginx (client_max_body_size) y timeouts.
 */
export const upload = async (image) => {
	if (!image)
		throw new Error('No se ha seleccionado ningún archivo de imagen.');

	const fileToSend = await shrinkImageForUpload(image);

	const formData = new FormData();
	formData.append('folder', 'groups');
	formData.append('file', fileToSend);

	const { data } = await baseClient().post('/file/single-file', formData);

	if (!data?.fileURL)
		throw new Error(
			data?.message || 'El servidor no devolvió la URL de la imagen.'
		);

	return data;
};

export const uploadSingleFile = (file, folder) => {
	if (!file) return Promise.reject(new Error('File must be provided'));

	const formData = new FormData();
	formData.append('folder', folder);
	formData.append('file', file);

	const URL = `${API}/file/single-file`;
	return authClient().post(URL, formData);
};

export const uploadFilesGetLinks = async (files, folder) => {
	let tmp_filesURLs = {};

	for (const key in files) {
		if (files[key] !== null && files[key] !== undefined && files[key] !== '') {
			const res = await uploadSingleFile(files[key], folder);
			if (res && res.status === 200 && res.data?.fileURL)
				tmp_filesURLs[key] = res.data.fileURL;
		}
	}

	return Object.values(tmp_filesURLs);
};
